import { CommonModule } from "@angular/common";
import { Component, inject, model, signal } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { UploadService } from "apps/admin/src/services/upload.service";
import { Icon, ToastService } from "@client";

@Component({
  selector: "app-thumbnail",
  imports: [CommonModule, Icon],
  templateUrl: "./thumbnail.component.html",
  styleUrl: "./thumbnail.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ThumbnailComponent,
      multi: true,
    },
  ],
})
export default class ThumbnailComponent implements ControlValueAccessor {
  readonly uploadService = inject(UploadService);
  readonly toastService = inject(ToastService);
  images = model<string[]>([]);

  async handleUpload() {
    const input = document.querySelector(
      "#app-profile-uploader"
    ) as HTMLInputElement;
    if (input) {
      input.click();

      input.onchange = async (e) => {
        const target = e.target as HTMLInputElement;
        const files = target.files;
        if (files) {
          const currentImages = this.images();
          const totalFilesCount = currentImages.length + files.length;

          if (totalFilesCount > 5) {
            this.toastService.error("최대 5개까지 업로드할 수 있습니다.");
            return;
          }

          const newImages: string[] = [];
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const res = await this.uploadService.upload(file);
            newImages.push(res.url);
          }

          const updatedImages = [...currentImages, ...newImages].slice(0, 5);
          this.images.set(updatedImages);
          this.onChange(updatedImages);
        }
      };
    }
  }

  deleteImage(index: number) {
    const currentImages = this.images();
    const [removed] = currentImages.splice(index, 1);
    this.images.set([...currentImages]);
    this.onChange([...currentImages]);
    this.uploadService.delete(removed);
  }

  onChange = (images: string[]): void => {};
  onTouched = (): void => {};

  writeValue(obj: string[]): void {
    this.images.set(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}
}
